import { takeLatest, call, put } from 'redux-saga/effects';
import moment from 'moment-timezone';

import api from 'api';
import {
  actions as analyticsActions,
  constants as analyticsEvents,
} from 'state/analytics';

import actions from 'state/downloads/actionCreators';
import constants from 'state/downloads/constants';
import types from 'state/downloads/actionTypes';

function* handleDownloadFile({ payload }) {
  const { fileType, dateFrom } = payload;

  const status = [
    constants.DONE,
    constants.DONE_WITHOUT_MANIFEST,
    constants.DONE_WITH_CANCELLATIONS,
    constants.CANCELLED,
  ];

  const dateTo = moment(dateFrom).endOf('month').format('YYYY-MM-DD');

  const apiCall =
    fileType === constants.POD ? api.downloadPodsZip : api.downloadCsv;
  const analyticsEvent =
    fileType === constants.POD
      ? analyticsEvents.shipperDownloadPodZip
      : analyticsEvents.shipperDownloadCsv;

  const params = {
    status,
    first_pickup_time: dateFrom,
    last_dropoff_time: dateTo,
    email: true,
  };

  try {
    yield put(actions.setDownloadSubmitting({ submitting: true }));
    yield put(analyticsActions.sendEvent(analyticsEvent(params)));
    yield call(apiCall, { params });
    yield put(actions.setDownloadRequestSuccessful({ success: true }));
  } catch (error) {
    yield put(actions.setDownloadRequestSuccessful({ success: false }));
  } finally {
    yield put(actions.setDownloadSubmitting({ submitting: false }));
  }
}

export default function* () {
  yield takeLatest(types.downloadFile$, handleDownloadFile);
}
